import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    BUYER: null,
    user: {},
  },
  getters: {
    buyer: (state) => state.BUYER,
    bookmarks: (state) => (state.BUYER ? state.BUYER.bookmark_products : []),
    isLoggedIn: (state) => state.user.email ? true : false,
    user: (state) => state.user,
  },
  mutations: {
    SET_BUYER(state, payload) {
      state.BUYER = payload;
    },
    SET_USER_DATA(state, data) {
      state.user = data.user;
    },
    DELETE_USER_DATA(state) {
      state.user = {};
    },
  },
  actions: {
    setUserData({ commit }, payload) {
      commit('SET_USER_DATA', payload);
    },
    setBuyer({ commit }, buyer) {
      commit('SET_BUYER', buyer);
    },
    deleteUserData({ commit }) {
      commit('DELETE_USER_DATA');
    },
  },
  plugins: [createPersistedState()],
});
